import { EnumStorageKeys } from '@/data/protocols/cache/keys'
import PathConstants from '@/main/routes/paths'
import { clearSessionId } from '@/data/services/login/session-id-store'

export const isSafeRedirectUrl = (url: string): boolean => {
  if (url.startsWith('/') && !url.startsWith('//')) return true
  try {
    return new URL(url).origin === window.location.origin
  } catch {
    return false
  }
}

export const getSafeRedirectUri = (searchParams: URLSearchParams, fallback = ''): string => {
  const raw = searchParams.get('redirect_uri') || ''
  return raw && isSafeRedirectUrl(raw) ? raw : fallback
}

export const redirectToLogin = (returnUrl?: string): void => {
  clearSessionId()

  const loginUrl = returnUrl
    ? `${PathConstants.Routes.LOGIN.value}?redirect_uri=${encodeURIComponent(returnUrl)}`
    : PathConstants.Routes.LOGIN.value

  window.location.replace(loginUrl)
}

/**
 * Clears all authentication-related data and cookies from the client.
 * Note: HttpOnly cookies can only be cleared by the server.
 */
export const clearAuthData = (): void => {
  const cookies = document.cookie.split(';')
  const hostname = window.location.hostname
  const expiration = 'expires=Thu, 01 Jan 1970 00:00:00 UTC'

  cookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim()

    // Clear for current path and domain
    document.cookie = `${cookieName}=; ${expiration}; path=/;`
    document.cookie = `${cookieName}=; ${expiration}; path=/; domain=${hostname};`

    // Clear for parent domain if applicable

    const domainParts = hostname.split('.')

    if (domainParts.length > 2) {
      const parentDomain = domainParts.slice(-2).join('.')
      document.cookie = `${cookieName}=; ${expiration}; path=/; domain=.${parentDomain};`
    }
  })

  sessionStorage.clear()
  localStorage.removeItem(EnumStorageKeys.APP_LANGUAGE)
  clearSessionId()
}
